import { useState } from 'react'
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext'
import { AuthContext } from '../context/AuthContext'
import { _DELETE, _UPDATE } from '../utils/patches'
import { useMutation, useQueryClient } from '@tanstack/react-query'

// date fns
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import { useStateContext } from '../context/StateContext'

const DocumentDetails = ({ doc }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [title, setTitle] = useState(doc.title)
  const [firstName, setFirstName] = useState(doc.firstName)
  const [lastName, setLastName] = useState(doc.lastName)
  const [error, setError] = useState(null)

  const { user } = useAuthContext(AuthContext)
  const { apiUrl } = useStateContext()
  const queryClient = useQueryClient()

  const resetForm = () => {
    setTitle(doc.title)
    setFirstName(doc.firstName)
    setLastName(doc.lastName)
    setError(null)
  }

  const { mutate: deleteDocument } = useMutation({
    mutationFn: async () => {
      return await _DELETE({
        route: `${apiUrl}/documents/` + doc._id,
        user
      })
    },
    onSuccess: () => {
      // Invalidate and refetch documents after deletion
      queryClient.invalidateQueries({ queryKey: ['documentsData'] })
    }
  })

  const { mutate: updateDocument } = useMutation({
    mutationFn: async () => {
      return await _UPDATE({
        route: `${apiUrl}/documents/` + doc._id,
        doc: { title, firstName, lastName },
        user
      })
    },
    onSuccess: () => {
      setIsEditing(false)
      queryClient.invalidateQueries({ queryKey: ['documentsData'] })
    },
    onError: (error) => {
      setError(error.message)
    }
  })

  const deleteDocumentFn = async () => {
    if (!user) {return}
    deleteDocument()
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!user) {
      setError('You must be logged in')
      return
    }
    updateDocument()
  }

  const handleCancel = () => {
    setIsEditing(false)
    resetForm()
  }

  return (
    <div className="doc-details">
      {!isEditing ? (
        <>
          <h4>{doc?.title}</h4>
          <p><strong>First Name: </strong>{doc?.firstName}</p>
          <p><strong>Last Name: </strong>{doc?.lastName}</p>
          {doc.createdAt && <p>{formatDistanceToNow(new Date(doc?.createdAt), { addSuffix: true })}</p>}
          <div className="actions">
            <span className="material-symbols-outlined" onClick={() => setIsEditing(true)}>edit</span>
            <span className="material-symbols-outlined" onClick={deleteDocumentFn}>delete</span>
          </div>
        </>
      ) : (
        <form onSubmit={handleSubmit}>
          <label>Title:</label>
          <input 
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <label>First Name:</label>
          <input 
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />

          <label>Last Name:</label>
          <input 
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />

          <div className="actions">
            <button type="submit">Save</button>
            <button type="button" onClick={handleCancel}>Cancel</button>
          </div>
          {error && <div className="error">{error}</div>}
        </form>
      )}
    </div>
  )
}

export default DocumentDetails
